import { v4 as uuidv4 } from "uuid";

// `crypto.randomUUID` throws outside secure contexts (HTTPS, or
// `localhost`/`127.0.0.1`) -- but the function reference still exists there,
// so a truthiness check (`crypto.randomUUID ? ... : ...`) never catches it;
// only a try/catch around the actual call does. This crashed the entire
// checkout page (not just tracking) on Circle's own plain-HTTP
// *.circledev.net dev/test domains before this fallback was in place.
export const generateIdempotencyKey = (): string => {
  try {
    return crypto.randomUUID();
  } catch {
    return uuidv4();
  }
};
